<template>
  <v-container>
    <ResourceDialog
      @save="save"
      ref="emailDialog"
      :cancellable="false"
      :closeable="false"
      :fields="FIELDS"
      :max-width="800"
      :processing="processing"
      title="Add your email to continue"
      center-title
    />
  </v-container>
</template>

<script setup>
import { getRecaptchaEnterpriseToken } from '@/shared/services/google_recaptcha_enterprise';
import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';
import useApi from '@/shared/composables/useApi';
import useEventBus from '@/shared/composables/useEventBus';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const FIELDS = [
  { text: 'Email', value: 'email' },
  { text: 'Confirm your email', value: 'confirmEmail' },
];

const emit = defineEmits(['error']);

const { api } = useApi();
const eventBus = useEventBus();
const router = useRouter();
const store = useStore();

const emailDialog = ref(null);
const processing = ref(false);

onMounted(() => {
  emailDialog.value.open({});
});

function emitError(message) {
  emit('error', message);
  eventBus.chime(message);
}

async function save(newVal) {
  if (newVal.email !== newVal.confirmEmail) {
    emitError('Emails do not match');
    return;
  }

  if (!newVal.email) {
    emitError('Please fill out all fields');
    return;
  }

  const token = await getRecaptchaEnterpriseToken();
  processing.value = true;

  try {
    const resp = await api.member.profile.update({
      email: newVal.email,
      token,
    });

    if (!resp?.data) return;

    store.commit('setProfile', null);
    store.commit('setAuthenticated', false);
    router.replace({
      name: 'CodeSent',
      query: { token: resp.data.code_id, email_sent_to: newVal.email },
    });
  } catch (error) {
    emitError(error);
  } finally {
    processing.value = false;
  }
}
</script>
